/* =========================================================
   Alternativas en la ficha de producto (snippets/mt-alternativas.liquid)
   - Las 3 más parecidas con la misma fórmula de la página de comparar:
     familia × 0.30 + notas (Jaccard) × 0.50 + ocasión (Jaccard) × 0.20, mostrada como % de similitud.
   - Al tocar una, popup que compara el perfume de la página con la alternativa.
   ========================================================= */
(function () {
  var NIV_ESTELA = ['Suave', 'Moderada', 'Fuerte', 'Enorme'];
  var NIV_DURACION = ['Débil (1–3 h)', 'Moderada (3–6 h)', 'Duradera (7–12 h)', 'Muy duradera (+12 h)'];
  var CUANTAS = 3;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
  function unicos(a) { var o = []; a.forEach(function (x) { if (x && o.indexOf(x) < 0) o.push(x); }); return o; }
  function jaccard(a, b) {
    a = unicos((a || []).map(norm)); b = unicos((b || []).map(norm));
    if (!a.length && !b.length) return 0;
    var c = a.filter(function (x) { return b.indexOf(x) > -1; }).length;
    return c / (a.length + b.length - c);
  }
  function familias(p) { return p.fam && p.fam.length ? p.fam : (p.fd ? p.fd.split(/\s+/) : []); }
  function simFamilia(a, b) {
    var fa = familias(a).map(norm).filter(Boolean), fb = familias(b).map(norm).filter(Boolean);
    if (!fa.length || !fb.length || fa[0] !== fb[0]) return 0;
    return (fa[1] || '') === (fb[1] || '') ? 1 : 0.5;
  }
  function similitud(a, b) { return simFamilia(a, b) * 0.30 + jaccard(a.no, b.no) * 0.50 + jaccard(a.oc, b.oc) * 0.20; }
  function esSet(p) { return /^set\b/i.test(p.t); }

  function init(el) {
    if (el.dataset.mtAltInit) return; el.dataset.mtAltInit = '1';
    var fmt = el.dataset.moneyFormat || '${{amount}}';
    var grid = el.querySelector('[data-mt-alt-grid]');
    var pcts = el.querySelector('[data-mt-alt-pcts]');
    var modal = el.querySelector('[data-mt-alt-modal]');
    var tabla = modal.querySelector('[data-mt-alt-tabla]');
    var btn = modal.querySelector('[data-mt-alt-carrito]');
    var aviso = modal.querySelector('[data-mt-alt-aviso]');
    var txtBtn = btn.innerHTML;
    var datos = {}, base = null, alts = [], actual = null, foco = null;
    // El popup va directo en <body> para que nada de la página lo recorte
    document.body.appendChild(modal);

    function money(c) { return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')); }
    function precio(p) { return money(p.p) + (p.c > p.p ? ' <s>' + money(p.c) + '</s>' : ''); }
    function foto(p) { return p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '<span class="mt-alt__sinfoto"></span>'; }

    function pintarTarjetas() {
      grid.innerHTML = alts.map(function (x) {
        var p = x.p;
        return '<button type="button" class="mt-alt__item" data-h="' + esc(p.h) + '" aria-label="Comparar con ' + esc(p.t) + '">' +
          '<span class="mt-alt__foto">' + foto(p) + '<span class="mt-alt__mas" aria-hidden="true">+</span></span>' +
          '<span class="mt-alt__nombre">' + esc(p.t) + '</span>' +
          '<span class="mt-alt__precio">' + precio(p) + '</span></button>';
      }).join('');
      pcts.innerHTML = alts.map(function (x) { return '<span class="mt-alt__pct">' + Math.round(x.s * 100) + '%</span>'; }).join('');
      el.hidden = false;
    }

    function barra(v, niveles) {
      var i = niveles.indexOf(v);
      if (i < 0) return v ? esc(v) : '<span class="mt-alt__nd">—</span>';
      var s = '<span class="mt-alt__barra" aria-hidden="true">';
      for (var k = 0; k < niveles.length; k++) s += '<i' + (k <= i ? ' class="on"' : '') + '></i>';
      return s + '</span>' + esc(v);
    }
    function chips(arr, comunes) {
      if (!arr || !arr.length) return '<span class="mt-alt__nd">—</span>';
      return '<span class="mt-alt__chips">' + arr.map(function (x) {
        return '<span class="mt-alt__chip' + (comunes && comunes.indexOf(norm(x)) > -1 ? ' is-comun' : '') + '">' + esc(x) + '</span>';
      }).join('') + '</span>';
    }

    function abrir(h) {
      var p = datos[h]; if (!p) return;
      actual = p;
      var na = unicos((base.no || []).map(norm)), nb = unicos((p.no || []).map(norm));
      var comunes = na.filter(function (x) { return nb.indexOf(x) > -1; });
      function fam(x) { var f = familias(x); return f.length ? esc(f.join(' · ')) : '<span class="mt-alt__nd">—</span>'; }
      var filas = [
        ['Estela', barra(base.es, NIV_ESTELA), barra(p.es, NIV_ESTELA)],
        ['Duración', barra(base.du, NIV_DURACION), barra(p.du, NIV_DURACION)],
        ['Familia olfativa', fam(base), fam(p)],
        ['Ocasión', chips(base.oc), chips(p.oc)],
        ['Notas', chips(base.no, comunes), chips(p.no, comunes)],
        ['Precio', '<span class="mt-alt__pr">' + precio(base) + '</span>', '<span class="mt-alt__pr">' + precio(p) + '</span>']
      ];
      // El perfume de esta página no es enlace; la alternativa lleva a su página
      tabla.innerHTML =
        '<div class="mt-alt__cab">' +
          '<div class="mt-alt__prod">' + foto(base) + '<span class="mt-alt__prod-et">Este perfume</span><span class="mt-alt__prod-n">' + esc(base.t) + '</span></div>' +
          '<a class="mt-alt__prod" href="' + esc(p.u) + '">' + foto(p) + '<span class="mt-alt__prod-et">Alternativa</span><span class="mt-alt__prod-n">' + esc(p.t) + '</span></a>' +
        '</div>' +
        filas.map(function (f) {
          return '<div class="mt-alt__fila"><div class="mt-alt__et">' + f[0] + '</div><div class="mt-alt__vals"><div>' + f[1] + '</div><div>' + f[2] + '</div></div></div>';
        }).join('');
      var ok = p.a && p.v;
      btn.disabled = !ok;
      btn.innerHTML = ok ? txtBtn : '<span>' + esc(el.dataset.txtAgotado) + '</span>';
      aviso.hidden = true;
      foco = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('mt-alt-abierto');
      modal.querySelector('.mt-alt__caja').scrollTop = 0;
      modal.querySelector('.mt-alt__x').focus();
    }
    function cerrar() {
      modal.hidden = true;
      document.body.classList.remove('mt-alt-abierto');
      if (foco && foco.focus) foco.focus();
    }

    grid.addEventListener('click', function (e) { var b = e.target.closest('.mt-alt__item'); if (b) abrir(b.dataset.h); });
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-mt-alt-cerrar]')) cerrar(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) cerrar(); });

    /* Agregar la alternativa al carrito (abre el carrito lateral) */
    btn.addEventListener('click', function () {
      if (!actual || !actual.v) return;
      btn.disabled = true; btn.classList.add('is-cargando');
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: actual.v, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (r) {
        if (r.status) { aviso.textContent = r.description || r.message || 'No se pudo agregar.'; aviso.hidden = false; return; }
        cerrar();
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.renderContents === 'function' && r.sections) { cd.classList.remove('is-empty'); cd.renderContents({ sections: r.sections, id: actual.v }); }
        else location.href = '/cart';
      }).catch(function () { location.href = '/cart'; })
        .finally(function () { btn.disabled = false; btn.classList.remove('is-cargando'); });
    });

    /* Carga del índice de perfumes */
    var url = '/collections/' + el.dataset.col + '?view=comparar';
    fetch(url).then(function (r) { return r.json(); }).then(function (j) {
      var pags = [Promise.resolve(j)];
      for (var i = 2; i <= (j.paginas || 1); i++) pags.push(fetch(url + '&page=' + i).then(function (r) { return r.json(); }));
      return Promise.all(pags);
    }).then(function (todas) {
      todas.forEach(function (j) { (j.items || []).forEach(function (p) { p.no = p.no || []; p.oc = p.oc || []; datos[p.h] = p; }); });
      base = datos[el.dataset.handle];
      if (!base) return;
      alts = Object.keys(datos).map(function (h) { return datos[h]; }).filter(function (c) {
        return c.h !== base.h && c.a && !esSet(c);
      }).map(function (c) { return { p: c, s: similitud(base, c) }; })
        .filter(function (x) { return x.s > 0; })
        .sort(function (a, b) { return b.s - a.s; })
        .slice(0, CUANTAS);
      if (alts.length) pintarTarjetas();
    }).catch(function () {});
  }

  function arrancar() { document.querySelectorAll('[data-mt-alt]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();
